function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from "react";
import Spacer from "noood/comp/ui/spacer/Spacer";
import Text from "noood/comp/text/Text";
import Icon from "noood/comp/ui/feather-icon/Icon";
import FlexCenterCenter from "noood/comp/ui/containers/FlexCenterCenter";
import { IAppContext } from "noood/contexts/contexts";
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary() {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ErrorBoundary, [].concat(args));
    _this.state = {
      error: null,
      error_message: null
    };
    return _this;
  }
  _inherits(ErrorBoundary, _React$Component);
  return _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      console.error('Caught by ErrorBoundary:', error, errorInfo);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement(IAppContext.Consumer, null, function (appContext) {
        var isDarkMode = (appContext === null || appContext === void 0 ? void 0 : appContext.lightOrDark) === 'dark';
        var textColor = isDarkMode ? '#fefefe' : '#333333';
        return /*#__PURE__*/React.createElement(React.Fragment, null, _this2.state.error && /*#__PURE__*/React.createElement(FlexCenterCenter, null, /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 5
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          icon: "x-circle",
          size: 50,
          color: "var(--shade-30)"
        }), /*#__PURE__*/React.createElement(Spacer, {
          mtop: 10
        }), /*#__PURE__*/React.createElement(Text, {
          size: 18
        }, _this2.state.error_message ? /*#__PURE__*/React.createElement(React.Fragment, null, _this2.state.error_message) : /*#__PURE__*/React.createElement(React.Fragment, null, "Something went wrong.")), /*#__PURE__*/React.createElement(Text, {
          size: 13,
          secondary: true
        }, _this2.state.error_message === 'ERROR_404' && /*#__PURE__*/React.createElement("div", {
          style: {
            maxWidth: "300px",
            textAlign: "center",
            paddingTop: "10px"
          }
        }, "The resource you are looking isn't available right now. Please try again later."), _this2.state.error_message !== 'ERROR_404' && /*#__PURE__*/React.createElement(React.Fragment, null, "An error occurred. Please try again later.")))), _this2.state.error === null && _this2.props.children);
      });
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(err) {
      return {
        error: err,
        error_message: err.message
      };
    }
  }]);
}(React.Component);
export default ErrorBoundary;